/** @format */

import {PlanPeriodInput} from '../types';

// Минимальная структурная форма плана (общая для list-query и body-query медиапланов):
// startOn обязателен (вызывающий код должен отфильтровать планы без startOn ДО маппинга),
// type/repeat с бэка — AccountsMediaplanType/AccountsMediaplanRepeat, здесь принимаем как string.
interface PlanShape {
  startOn: string;
  endOn?: string | null;
  type: string;
  repeat?: string | null;
}

// repeat сохраняется только для повторяющихся планов (type === 'REPEATABLE'); для FLIGHT — null.
// endOn ?? null нормализует отсутствие даты окончания (открытый план).
export const toPlanPeriodInput = (plan: PlanShape): PlanPeriodInput => ({
  startOn: plan.startOn,
  endOn: plan.endOn ?? null,
  repeat: plan.type === 'REPEATABLE' ? ((plan.repeat ?? null) as PlanPeriodInput['repeat']) : null,
});
